
export const getFirstTimeLoad = state => {
  return state.firstTimeLoad
}

export const getMainListSavedFilter = state => {
  return state.mainListSavedFilter
}

export const getMainListQuickFilter = state => {
  return state.mainListQuickFilters
}

export const getQuickFiltersDatesFrom = state => {
  return state.quickFiltersDatesFrom
}

export const getQuickFiltersDatesTo = state => {
  return state.quickFiltersDatesTo
}

export const getSortField = state => {
  return state.sortField
}

export const getSortFieldId = state => {
  return state.sortFieldId
}

export const getSortOrder = state => {
  return state.sortOrder
}

export const getPage = state => {
  return state.page
}

export const getRows = state => {
  return state.rows
}

export const getHardLoad = state => {
  return state.hardLoad
}

export const getSoftReload = state => {
  return state.softReload
}

export const getSearchText = state => {
  return state.searchText
}

export const getScrollY = state => {
  return state.scrollY
}

export const getGridScrollY = state => {
  return state.gridScrollY
}
